import type { AccentId } from "./types.js";

export interface AccentOption {
  readonly id: AccentId;
  readonly hex: string;
  readonly label: string;
}

export const ACCENTS: readonly AccentOption[] = [
  { id: "pink", hex: "#F0145A", label: "Rosa" },
  { id: "blue", hex: "#1F6FEB", label: "Azul" },
  { id: "green", hex: "#0E8A5F", label: "Verde" },
  { id: "amber", hex: "#8A5A00", label: "Âmbar" },
  { id: "ink", hex: "#111111", label: "Preto" },
];

const INVITE_VEIL = "#2B2B2B";

function luminance(hex: string): number {
  const channel = (offset: number) => {
    const value = parseInt(hex.slice(offset, offset + 2), 16) / 255;
    return value <= 0.03928 ? value / 12.92 : ((value + 0.055) / 1.055) ** 2.4;
  };
  return 0.2126 * channel(1) + 0.7152 * channel(3) + 0.0722 * channel(5);
}

export function contrastRatio(first: string, second: string): number {
  const [light, dark] = [luminance(first), luminance(second)].sort((a, b) => b - a) as [
    number,
    number,
  ];
  return (light + 0.05) / (dark + 0.05);
}

export function accentHex(id: AccentId): string {
  return (ACCENTS.find((option) => option.id === id) ?? (ACCENTS[0] as AccentOption)).hex;
}

export function accentReadable(id: AccentId): boolean {
  return contrastRatio(accentHex(id), INVITE_VEIL) >= 3;
}

export function ringColor(id: AccentId): string {
  return accentReadable(id) ? accentHex(id) : "var(--brand-mark)";
}
